import type { RouteObject } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import Home from '@/pages/home/page';
import CategoryPage from '@/pages/category/page';
import ArticlePage from '@/pages/article/page';
import AboutPage from '@/pages/about/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'category/:slug', element: <CategoryPage /> },
      { path: 'article/:id', element: <ArticlePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;